module.exports = __webpack_public_path__ + "static/media/search_slider_phone1.aae9dcd2.png";